import { createSelector } from 'reselect';
import { categoryUrlSelector } from '../../url';
import { pendingResponse } from '../../../fetchStatus';
import { vehicleFilterStateSelector } from '../vehicleFilter';

export const productsResponseByCategoryUrlSelector = createSelector(
    [vehicleFilterStateSelector],
    vehicleFilterState => vehicleFilterState.products
);

export const productsResponseSelector = createSelector(
    [productsResponseByCategoryUrlSelector, categoryUrlSelector],
    (productsResponseByCategoryUrl, categoryUrl) => productsResponseByCategoryUrl?.[categoryUrl] ?? pendingResponse
);

export const productsDataSelector = createSelector([productsResponseSelector], productsResponse => productsResponse?.data);

export const productsSelector = createSelector([productsDataSelector], productsData => productsData?.products);

export const productsFilterValuesSelector = createSelector([productsDataSelector], productsData => productsData?.filterValues);
export const productsFilterOptionsSelector = createSelector([productsDataSelector], productsData => productsData?.filterOptions);
